import { expVal } from '@confluence/feature-experiments';

/**
 * Hook for consumers to check if the connector onboarding experiment is enabled.
 * Use this to conditionally render a ConnectorPromo* entry point component.
 *
 * @example
 * ```tsx
 * const { isEnabled } = useIsConnectorOnboardingEnabled();
 * {isEnabled && <ConnectorPromoNavSearch />}
 * ```
 */
export function useIsConnectorOnboardingEnabled(): { isEnabled: boolean } {
	return { isEnabled: expVal('twcg-1489-cc-3p-connector-onboarding', 'isEnabled', false) };
}
